export default "__VITE_ASSET__q$VjH8xj__"